// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2uPCh","inner":"Form_inner__34wT9","range":"Form_range__3Dh85","name":"Form_name__3zqEW","actions":"Form_actions__1wv6k"};